import React, { useEffect, useState } from 'react';
import { Col, Container, Modal, Row } from 'react-bootstrap';
import { DataGrid } from '@mui/x-data-grid';
import { Alert, Button, Snackbar, Switch } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteOne_Rotation_Data, GetAll_Rotation_Data } from '../Redux/Actions/Rotations_Actions';
import CopyToClipboard from 'react-copy-to-clipboard';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Link } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import { Notify } from '../Utility/Notify';
import { useTheme } from '@mui/material/styles';

export const ManageRotationPage = () => {
  const [userlogin, setuserlogin] = useState('');
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

  // modal Delete
  const [showdelete, setShowdelete] = useState(false);
  const handleClosedelete = () => setShowdelete(false);

  const dispatch = useDispatch();

  const getAllRotation = async () => {
    await dispatch(GetAll_Rotation_Data());
  };

  useEffect(() => {
    getAllRotation();
  }, []);

  const resallrotation = useSelector((state) => state.AllRotation.Rotation);
  let AllrotationArray = Array.isArray(resallrotation?.data) ? resallrotation.data : [];

  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (Array.isArray(resallrotation?.data)) {
      const transformedRows = resallrotation.data.map((item) => ({
        id: item._id, // استخدام _id كـ id في الجدول
        RotationId: item._id,
        Sales: item.sales.map((sale) => `${sale.salesId.name} (${sale.maxLeads})`).join(', '),
        Projects: item.projects.map((project) => project.name).join(', '), // دمج أسماء المشاريع
        Channel: item.channels.map((channel) => channel.name).join(', '), // دمج أسماء القنوات
        CreatedAt: new Date(item.createdAt).toLocaleDateString(), // تنسيق تاريخ الإنشاء
        Active: item.active, // حالة التبديل
      }));
      setRows(transformedRows);
    }
  }, [resallrotation]);

  const handleChangeSwitch = (id) => (event) => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, Active: event.target.checked } : row)),
    );
  };

  const handleButtonClickupdate = async (id, buttonType) => {
    // console.log(`Button clicked for Rotation ID: ${id}, Type: ${buttonType}`);
  };

  const [decomentid, setdecumentid] = useState();
  const handleButtonClickdelete = (id, buttonType) => {
    // console.log(`Button clicked for Rotation ID: ${id}, Type: ${buttonType}`);
    setdecumentid(id);
    setShowdelete(true);
  };

  //clipboard copy channal id
  const [open, setOpen] = useState(false);
  const handleCopy = () => {
    setOpen(true); // عرض رسالة تأكيد عند النسخ
    setTimeout(() => setOpen(false), 2000); // إخفاء الرسالة بعد 2 ثانية
  };

  const columns = [
    {
      field: 'RotationId',
      headerName: 'RotationId',
      width: 150,
      renderCell: (params) => (
        <div style={{ cursor: 'pointer', textAlign: 'center' }}>
          {' '}
          <CopyToClipboard onCopy={handleCopy}>
            <div onClick={() => navigator.clipboard.writeText(params.row.id)}>
              <ContentCopyIcon />
            </div>
          </CopyToClipboard>
          <Snackbar open={open} autoHideDuration={2000}>
            <Alert severity="success">Copy Done</Alert>
          </Snackbar>
        </div>
      ),
    },
    { field: 'Sales', headerName: 'Sales', width: 200 },
    { field: 'Projects', headerName: 'Projects', width: 200 },
    { field: 'Channel', headerName: 'Channel', width: 200 },
    { field: 'CreatedAt', headerName: 'Created At', width: 150 },
    {
      field: 'Active',
      headerName: 'Active',
      width: 150,
      renderCell: (params) => (
        <Switch
          checked={params.row.Active || false}
          onChange={handleChangeSwitch(params.row.id)}
          inputProps={{ 'aria-label': 'controlled' }}
          disabled={true} // هذا سيجعل الـ Switch غير قابل للتفاعل
        />
      ),
    },
    {
      field: 'Action',
      headerName: 'Action',
      width: 200,
      renderCell: (params) => (
        <div>
          <Link to={`/EditRotation/${params.row.id}`} style={{ textDecoration: 'none' }}>
            <Button
              variant="outlined"
              onClick={() => handleButtonClickupdate(params.row.id, 'edit')}
              style={{ marginRight: 10 }}
            >
              <SyncAltIcon />
            </Button>
          </Link>

          <Button
            variant="outlined"
            onClick={() => handleButtonClickdelete(params.row.id, 'delete')}
            className="mx-2"
          >
            <DeleteIcon />
          </Button>
        </div>
      ),
    },
  ];

  // delete rotation
  const handledeleting = async (e) => {
    e.preventDefault();
    await dispatch(DeleteOne_Rotation_Data(decomentid));

    Notify('success', 'Rotation Deleted Successfully', 'success');

    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  // ==============================
  // تحديد المسار بناءً على دور المستخدم
  const rotationRoute =
    userlogin?.data?.role === 'Admin'
      ? '/AllLeadsForAdmin' // Admin يذهب إلى /MoreRotation
      : userlogin?.data?.role === 'Marketer'
        ? '/ALLLeadsForMarketer' // Marketer يذهب إلى /MarketerMoreRotation
        : '/'; // مسار افتراضي لأي دور آخر

  return (
    <Container className="startpage">
      {/* model deleting rotation */}

      <Modal style={{ zIndex: '40000' }} show={showdelete} onHide={handleClosedelete}>
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title
            style={{
              color: mode === 'dark' ? '#90caf9' : '#0F7687',
              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
            }}
          >
            Modal Delete Rotation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          {' '}
          Are you sure For deleting this Rotation !
        </Modal.Body>
        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button variant="secondary" onClick={handleClosedelete}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handledeleting}
            style={{
              color: mode === 'dark' ? '#90caf9' : '#0F7687',
              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
            }}
          >
            Confirm Deleting
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="my-3">
        <div>
          <Link
            to={rotationRoute}
            style={{ textDecoration: 'none', color: '#0F7687', fontWeight: 'bold' }}
          >
            <span style={{ fontWeight: 'bold' }}>Home</span>
          </Link>
          <KeyboardDoubleArrowRightIcon />

          <span>Rotation</span>
          <KeyboardDoubleArrowRightIcon />
          <span>Manage Rotation</span>
        </div>
      </div>
      <Row>
        <Col sm={0}></Col>
        <Col sm={12}>
          <div style={{ height: 700, width: '100%' }}>
            <DataGrid rows={rows} columns={columns} pageSize={5} rowsPerPageOptions={[5]} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};
